import { AccessAction, SET_ACCESSIBILITY } from '../type';

export const setAccessibility = (access: string): AccessAction => {
    localStorage.setItem('accessibility', access);
    return {
        type: SET_ACCESSIBILITY,
        payload: access
    };
};
